import { NgModule } from '@angular/core';

import { JwtHelperService, JwtModule } from '@auth0/angular-jwt';

import { SegurancaRoutingModule } from './seguranca-routing.module';
import { AuthGuard } from './auth.guard';

// função para retornar o token.
export function tokenGetter(): string {
  return localStorage.getItem('token');
}

@NgModule({
  imports: [
    // Adicionar o token nos Headers das requisições.
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        // TODO: ADICIONAR OS DE PROD
        allowedDomains: [
          // 'localhost:8080',
          'amm-homologacao.azurewebsites.net'], // Requisições liberadas para interceptação
        disallowedRoutes: [
          // 'http://localhost:8080/oauth/token',
          // 'http://localhost:8080/usuarios/esqueceu-senha',
          // 'http://localhost:8080/usuarios/nova-senha/**',
          'https://amm-homologacao.azurewebsites.net/oauth/token',
          'https://amm-homologacao.azurewebsites.net/usuarios/esqueceu-senha',
          'https://amm-homologacao.azurewebsites.net/usuarios/nova-senha/**'
        ] // Sem interceptação.
      }
    }),
    SegurancaRoutingModule
  ],
  providers: [
    JwtHelperService,
    AuthGuard
  ]
})
export class SegurancaModule { }
